import React, {useState} from 'react';

import CSSModules from 'react-css-modules';

import ShrinkText from '../../ShrinkText';
import Heading from '../../TextComponents/Heading';
import {createMarkup, renderMarkdown} from '../../utils/markdownUtils';
import TaskBoxButton from './TaskBoxButton';

import styles from './styles.module.scss';

type CommonProps = {
  headingText?: string;
  text?: string;
  textPlaceholder?: string;
  buttonText: string;
  disabled?: boolean;
  reskinClassName?: string;
  textColour?: string;
  background?: string;
};

type ConditionalEditModeProps =
  | {
      editMode?: false;
      onButtonClick: () => void;
      interactionComplete: boolean;
      interaction: React.ReactNode;
    }
  | {
      editMode?: true;
      onButtonClick?: never;
      interactionComplete?: never;
      interaction?: never;
    };

type TaskBoxProps = CommonProps & ConditionalEditModeProps;

const TaskBox = ({
  headingText,
  text,
  textPlaceholder,
  buttonText,
  onButtonClick,
  interactionComplete,
  interaction,
  disabled,
  editMode,
  reskinClassName = '',
  textColour,
  background,
}: TaskBoxProps): JSX.Element => {
  const [showInteraction, setShowInteraction] = useState(false);

  const handleButtonClick = () => {
    setShowInteraction(true);
    if (onButtonClick) {
      onButtonClick();
    }
  };

  const isInInteraction = showInteraction && !interactionComplete;

  return (
    <div
      styleName={`task-box ${reskinClassName}`}
      style={{backgroundColor: background, color: textColour}}
    >
      <Heading
        as='h3'
        size='cat'
        weight='bold'
        colour={textColour === '#1E1E34' ? 'textPrimary' : 'white'}
        dataAutomation='component-title'
      >
        {headingText}
      </Heading>
      <div
        styleName={!text ? 'alphaText' : ''}
        data-automation='component-description'
        dangerouslySetInnerHTML={createMarkup(
          renderMarkdown(text || textPlaceholder || '')
        )}
      />
      <div styleName='button-container'>
        <ShrinkText
          maxPxWidth={Math.min(window.innerWidth - 60, 440)} // 20 + 40px = padding
          startingFontSize='m'
          minimumFontSize='s'
        >
          <TaskBoxButton
            onClick={handleButtonClick}
            isDisabled={isInInteraction || disabled || editMode}
            text={buttonText}
          />
        </ShrinkText>
      </div>
      {isInInteraction && interaction}
    </div>
  );
};

export default CSSModules(TaskBox, styles, {allowMultiple: true});
